import styled from 'styled-components'
import { spacing } from '../../styles/utilities/variables'

const StyledMain = styled.main`
  padding: ${props => props.spacing ? `${spacing.large} 0` : `0 0`};
`

export default StyledMain
